import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/yunfuMaster2022/banner.jpg'
import navColor from '../../assets/yunfuMaster2022/nav/color.jpg'
import navBg from '../../assets/yunfuMaster2022/nav/nav_bg.png'
import navBgFixed from '../../assets/yunfuMaster2022/nav/nav_bg_fixed.png'

import far1 from '../../assets/yunfuMaster2022/nav/far1.png'
import far1_active from '../../assets/yunfuMaster2022/nav/far1_active.png'
import far2 from '../../assets/yunfuMaster2022/nav/far2.png'
import far2_active from '../../assets/yunfuMaster2022/nav/far2_active.png'
import son1 from '../../assets/yunfuMaster2022/nav/son1.png'
import son1_active from '../../assets/yunfuMaster2022/nav/son1_active.png'
import son2 from '../../assets/yunfuMaster2022/nav/son2.png'
import son2_active from '../../assets/yunfuMaster2022/nav/son2_active.png'
import son3 from '../../assets/yunfuMaster2022/nav/son3.png'
import son3_active from '../../assets/yunfuMaster2022/nav/son3_active.png'
import son4 from '../../assets/yunfuMaster2022/nav/son4.png'
import son4_active from '../../assets/yunfuMaster2022/nav/son4_active.png'
import son5 from '../../assets/yunfuMaster2022/nav/son5.png'
import son5_active from '../../assets/yunfuMaster2022/nav/son5_active.png'
import son6 from '../../assets/yunfuMaster2022/nav/son6.png'
import son6_active from '../../assets/yunfuMaster2022/nav/son6_active.png'
import son7 from '../../assets/yunfuMaster2022/nav/son7.png'
import son7_active from '../../assets/yunfuMaster2022/nav/son7_active.png'
import son8 from '../../assets/yunfuMaster2022/nav/son8.png'
import son8_active from '../../assets/yunfuMaster2022/nav/son8_active.png'

import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(149),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(149),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(149),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: `${calcRemFn(26)} ${calcRemFn(40)} 0`
  },
  topBtnBaseCss: {
    width: calcRemFn(100),
    height: calcRemFn(33.5),
    padding: `0 ${calcRemFn(3)}`
  },
  bottomBtnLayout: {
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    padding: `${calcRemFn(10)} 0 0 ${calcRemFn(60)}`
  },
  bottomBtnBaseCss: {
    width: calcRemFn(50),
    height: calcRemFn(18),
    padding: `${calcRemFn(2)} ${calcRemFn(5)}`
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active
      },
      {
        key: '_i5',
        show: true,
        img: son5,
        img_actived: son5_active,
        style: {
          paddingLeft: `${calcRemFn(40)}`
        }
      },
      {
        key: '_i6',
        show: true,
        img: son6,
        img_actived: son6_active
      },
      {
        key: '_i7',
        show: true,
        img: son7,
        img_actived: son7_active
      },
      {
        key: '_i8',
        show: true,
        img: son8,
        img_actived: son8_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active
      },
      {
        key: '_i4',
        show: true,
        img: son4,
        img_actived: son4_active
      },
      {
        key: '_i5',
        show: true,
        img: son5,
        img_actived: son5_active,
        style: {
          paddingLeft: `${calcRemFn(40)}`
        }
      },
      {
        key: '_i6',
        show: true,
        img: son6,
        img_actived: son6_active
      },
      {
        key: '_i7',
        show: true,
        img: son7,
        img_actived: son7_active
      },
      {
        key: '_i8',
        show: true,
        img: son8,
        img_actived: son8_active
      }
    ]
  }
}

const top1Prod = 28434
const top2Prod = 28431

const pictureList = [
  {
    key: '1_1',
    picNum: 6,
    pid: top1Prod
  },
  {
    key: '1_2',
    picNum: 5,
    pid: top1Prod
  },
  {
    key: '1_3',
    picNum: 5,
    pid: top1Prod
  },
  {
    key: '1_4',
    picNum: 2,
    pid: top1Prod
  },
  {
    key: '1_5',
    picNum: 2,
    pid: top1Prod
  },
  {
    key: '1_6',
    picNum: 2,
    pid: top1Prod
  },
  {
    key: '1_7',
    picNum: 2,
    pid: top1Prod
  },
  {
    key: '1_8',
    picNum: 4,
    pid: top1Prod
  },
  {
    key: '2_1',
    picNum: 6,
    pid: top2Prod
  },
  {
    key: '2_2',
    picNum: 4,
    pid: top2Prod
  },
  {
    key: '2_3',
    picNum: 3,
    pid: top2Prod
  },
  {
    key: '2_4',
    picNum: 1,
    pid: top2Prod
  },
  {
    key: '2_5',
    picNum: 1,
    pid: top2Prod
  },
  {
    key: '2_6',
    picNum: 1,
    pid: top2Prod
  },
  {
    key: '2_7',
    picNum: 1,
    pid: top2Prod
  },
  {
    key: '2_8',
    picNum: 2,
    pid: top2Prod
  }
]
function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/yunfuMaster2022/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'gold',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

pictures.unshift({
  son: [
    require('../../assets/yunfuMaster2022/ctn/1_0_1.jpg')
  ],
})

const topDiff = {
  firstSon: '_i1'
}

export default {
  title: '孕妇照',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
}
